import React from "react";
import {
    Card,
    CardHeader,
    Typography,
    Tooltip,
    Box,
    CardContent,
    IconButton,
    Stack,
} from "@mui/material";

import ListItemMenu from "../../../Common/ListItemMenu";

import PORTAvatar from "../PORTAvatar";
import ActivityStatusDetails from "./ActivityStatusDetails";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import ActivityReviewStatusIcon from "./ActivityReviewStatusIcon";
import LinkButton from "../../../Common/Button/LinkButton";
import DisplayCategories from "../Category/DisplayCategories";

function ActivityCard({ activity, onDelete, onEdit }) {
    const title = activity?.title || "Activity";

    const activityType = !!activity?.type?.name
        ? activity.type.name
        : "Undefined";
    const associationCount = !!activity?.associations?.length
        ? activity.associations.length
        : 0;

    const reviewCompleted = activity?.review?.status === "completed";
    const reviewRequired = activity?.review?.isRequired;

    let alert = {
        active: false,
        severity: "",
        message: "",
    };

    if (!reviewCompleted && reviewRequired) {
        alert.active = true;
        alert.severity = "warning";
        alert.message = "Reflection required";
    }

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={
                    <PORTAvatar
                        type={"activity"}
                        badge={associationCount > 0 ? "attached" : ""}
                    />
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        <ListItemMenu
                            onDelete={!!activity?.canDelete && onDelete}
                            onEdit={activity?.canUpdate && onEdit}
                        />
                        <LinkButton
                            to={`/portfolio/activities/${activity.id}`}
                        />
                    </Stack>
                }
                title={
                    <Typography component="h2" className="card-header-title">
                        {title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {activityType}
                    </Typography>
                }
            />
            <CardContent>
                <ActivityStatusDetails
                    dateStart={activity?.dateStart}
                    dateEnd={activity?.dateEnd}
                    duration={activity?.duration}
                    score={activity?.score}
                />
                <Box className="card-content">
                    <Typography variant="body1">
                        {activity?.description ?? "No description provided."}
                    </Typography>
                </Box>
            </CardContent>

            <CardContent>
                <Box className="card-content">
                    <DisplayCategories categories={activity?.categories} />
                </Box>
            </CardContent>

            <CardContent>
                <Box className="card-content">
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        spacing={0}
                    >
                        <Tooltip title="Reflection" placement="top" arrow>
                            <IconButton aria-label="reflection">
                                <ActivityReviewStatusIcon
                                    status={activity?.review?.status}
                                    isRequired={activity?.review?.isRequired}
                                />
                            </IconButton>
                        </Tooltip>

                        <Tooltip
                            title="Development needs"
                            placement="top"
                            arrow
                        >
                            <IconButton aria-label="development-needs">
                                <AutoGraphIcon
                                    fontSize={"small"}
                                    color={
                                        activity?.developmentNeeds?.length > 0
                                            ? "success"
                                            : "default"
                                    }
                                />
                            </IconButton>
                        </Tooltip>

                        <Tooltip
                            title="Attached resources"
                            placement="top"
                            arrow
                        >
                            <IconButton aria-label="attachments">
                                <AttachFileIcon
                                    fontSize={"small"}
                                    color={
                                        activity?.resources?.length > 0
                                            ? "success"
                                            : "default"
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    );
}

export default ActivityCard;
